// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__28GeD","checkboxCol":"Table_checkboxCol__-7w6B","emailCol":"Table_emailCol__3py7A","actionCol":"Table_actionCol__1kSq_"};